
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { formatDateWithTime, formatBool } from "@/utils";
import { EditStockAdjustmentDetail } from "@/models/api/barcodeSystem/stockAdjustments/edit";
import BarcodeCompanyModule from "@/store/modules/barcodeSystem/barcodeCompany";
import StockAdjustmentDetail from "@/components/barcodeSystem/stockAdjustment/StockAdjustmentDetail.vue";

const barcodeCompanyModuleState = getModule(BarcodeCompanyModule);

@Component({
  components: {
    StockAdjustmentDetail
  }
})
export default class StockAdjustmentDetailTable extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: null })
  editStockAdjustmentDetails: Array<EditStockAdjustmentDetail> | null;

  @Prop({ default: null })
  facilityCode: string;

  @Prop({ default: false })
  readonly: boolean;

  currentEditStockAdjustmentDetailCopy: EditStockAdjustmentDetail | null = null;
  currentEditStockAdjustmentDetail: EditStockAdjustmentDetail | null = null;
  showUpdateDetailModal: boolean = false;
  selectedItemIndexes: Array<number> = [];

  get selectedItemCount(): number {
    return this.selectedItemIndexes ? this.selectedItemIndexes.length : 0;
  }

  get totalItems() {
    if (this.editStockAdjustmentDetails) {
      return this.editStockAdjustmentDetails.length
    } else {
      return 0;
    }
  }
 
  getDamagedMessage(detail : EditStockAdjustmentDetail) : string {
    let damageMessage = formatBool(detail.isDamaged);
    if(detail && detail.isDamaged) {
      if(detail.damageCode)
        damageMessage = damageMessage + ' ' + detail.damageCode + '';
    }
    return damageMessage;
  }

  isSelected(index) {
    return this.selectedItemIndexes.indexOf(index) >= 0;
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val);
  }

  formatBool(val){
    return formatBool(val);
  }

  onDoubleClicked(data) {
    this.openEditDetailModal(data);
  }

  openEditDetailModal(data) {
    /*if(!this.readonly)
    {*/
      this.currentEditStockAdjustmentDetail = data;
      this.currentEditStockAdjustmentDetailCopy = JSON.parse(JSON.stringify(data));
      this.showUpdateDetailModal = true;
    //}
  }

  isValidDetail() : boolean {
    if(this.currentEditStockAdjustmentDetailCopy) {
      return true;
    }
    return false;
  }

  updateDetail() {
    if(this.currentEditStockAdjustmentDetail && this.isValidDetail()) {
      this.currentEditStockAdjustmentDetail.itemDescription = this.currentEditStockAdjustmentDetailCopy.itemDescription;
      this.currentEditStockAdjustmentDetail.itemScan = this.currentEditStockAdjustmentDetailCopy.itemScan;
      this.currentEditStockAdjustmentDetail.itemType = this.currentEditStockAdjustmentDetailCopy.itemType;
      this.currentEditStockAdjustmentDetail.manufacturerCode = this.currentEditStockAdjustmentDetailCopy.manufacturerCode;
      this.currentEditStockAdjustmentDetail.companyId = this.currentEditStockAdjustmentDetailCopy.companyId;
      this.currentEditStockAdjustmentDetail.company = this.currentEditStockAdjustmentDetailCopy.company;
      this.currentEditStockAdjustmentDetail.modelNumber = this.currentEditStockAdjustmentDetailCopy.modelNumber;
      this.currentEditStockAdjustmentDetail.poNumber = this.currentEditStockAdjustmentDetailCopy.poNumber;
      this.currentEditStockAdjustmentDetail.quantity = this.currentEditStockAdjustmentDetailCopy.quantity;
      this.currentEditStockAdjustmentDetail.serialNumber = this.currentEditStockAdjustmentDetailCopy.serialNumber;
      this.currentEditStockAdjustmentDetail.sku = this.currentEditStockAdjustmentDetailCopy.sku;
      this.currentEditStockAdjustmentDetail.bulkScan = this.currentEditStockAdjustmentDetailCopy.bulkScan;
      this.currentEditStockAdjustmentDetail.soNumber = this.currentEditStockAdjustmentDetailCopy.soNumber;
      this.currentEditStockAdjustmentDetail.warehouseLocationId = this.currentEditStockAdjustmentDetailCopy.warehouseLocationId;
      this.currentEditStockAdjustmentDetail.warehouseLocationCode = this.currentEditStockAdjustmentDetailCopy.warehouseLocationCode;
      this.currentEditStockAdjustmentDetail.isBulkItem = this.currentEditStockAdjustmentDetailCopy.isBulkItem;
      this.currentEditStockAdjustmentDetail.isDamaged = this.currentEditStockAdjustmentDetailCopy.isDamaged;
      this.currentEditStockAdjustmentDetail.damageCode = this.currentEditStockAdjustmentDetailCopy.damageCode;
    }
  }

  onRowClick(data, index) {
    this.unselectAll();
    this.switchSelectionStatus(index);
  }

  switchSelectionStatus(index)
  {
    if(this.selectedItemIndexes.indexOf(index) == -1)
      this.selectedItemIndexes.push(index);
  }

  unselectAll() {
    this.selectedItemIndexes = [];
  }

  closeModals() {
    this.showUpdateDetailModal = false;
  }

}
